import "./App.css";
import "semantic-ui-css/semantic.min.css";
import TableView from "./components/TableView";

function App() {
  return (
    <div style={{ height: "1400px" }}>
      <TableView />
    </div>
  );
}

export default App;
